export default {
    path: '/paylist',
    meta: {
        title: '支付记录',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/paylist`),
}


// WEBPACK FOOTER //
// ./src/views/PayList/router.js